import { ActivationBanner } from "../../components/ActivationBanner"
import { SettingsNavLinks } from "../../components/SettingsNavLinks"
import { Card, QuickTable, QuickTableFilterTabs, SwitchAppButton } from "../../components"
import { invoiceDisplayFormatter } from "./TeamSecurityFommater"
import { ITeamViewProps } from "./TeamSecurityLink"




export const View = (props: ITeamViewProps) =>{


    return(

        <>
            <SettingsNavLinks
      navtitle="Settings"
      navtitlelink="Security"
      />
      <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
      />
      <div className="security-team-table header">
            <strong>Account</strong>
            <p>The list of accounts to which you are a member.</p>
      </div>
      <QuickTable
        id="securityTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        itemCount={props.totalCount}
        renderDetail={(item) => item.description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={invoiceDisplayFormatter}
        onExport={props.onExport}
        onCreateNew={props.onCreateNew}
        createNewButtonText={"Add member"}
      />

        </>
    )
}
